import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { DRONE_MAP, UPLOADING, HELP} from '../../Routes';
import { Container } from '../Container';
import mapImg from '../../assets/images/landing_map.jpg';
import forestImg from '../../assets/images/landing_forest.jpg';
import helpImg from '../../assets/images/documents.jpg';
import './Landing.css';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding: 80px 0 40px 0;
  column-gap: 1rem;
  row-gap: 1rem;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    padding: 40px 0;
  }

  @media screen and (min-width: 992px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const Item = styled(Link)`
  display: block;

  img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    display: block;
  }

  span {
    display: block;
    background-color: ${({theme}) => theme.colors.bg_gray};
    color: ${({theme}) => theme.colors.heading_dark};
    padding: 1.5rem;
    font-size: 1.25rem;
    font-weight: bold;
    border-top: 5px solid ${({theme}) => theme.colors.brand_green};
    transition: all .5s ease;
  }

  &:hover {
    span {
      border-top: 5px solid ${({theme}) => theme.colors.brand_blue};
    }
  }
`;

function LandingPage() {

  return (
    <div>
      <section className="hero-section">
        <div className="hero-section-background">
            <div className="hero-section-background-image" />
        </div>
        <div className="yellow-box-container">
            <section className="yellow-box">
                <h1 className="yellow-box-heading">Drone Platform </h1>
                <p >by Stora Enso</p>
            </section>
        </div>
      </section>

      <Container>
        <Grid>
          <Item to={DRONE_MAP}>
           <img src={mapImg} alt="Map" />
           <span>Map</span>
          </Item>

          <Item to={UPLOADING}>
            <img src={forestImg} alt="Upload" />
            <span>Uploading</span>
          </Item>

          <Item to={HELP}>
            <img src={helpImg} alt="Help" />
            <span>Help</span>
          </Item>

        </Grid>
      </Container>

    </div>
  )
};

export default LandingPage;